import {
  TerminDetail, TerminDetailApi,
} from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new TerminDetailApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const fetchTerminDetail = async (
  uuid?: Uuid,
  admin?: boolean,
  options: { headers?: AxiosRequestHeaders } = {},
):
  Promise<ClientResponse<TerminDetail>> => {
  const {
    data,
    status,
  } = admin
    ? await client.getTerminDetailAdmin(uuid, options)
    : await client.getTerminDetail(uuid, options);

  data.previazanyTerminList.sort((a, b) => a.order - b.order);

  return {
    data,
    responseCode: status,
  };
};
